/*
 * Author: Harper Yan
 * File Created: Friday, 24-08-09 04:01 pm
 * Last Modified: Wednesday, 24-11-27 03:00 pm, by Harper Yan
 */

import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import type { ContainerProps, SxProps } from '@mui/material';
import { Box, Container } from '@mui/material';
export interface SectionBoxProps extends ContainerProps {
  layerSx?: SxProps;
}
function SectionBox({
  layerSx,
  children,
  sx,
  ...props
}: SectionBoxProps, ref: ForwardedRef<HTMLDivElement>) {
  return <Box component="section" ref={ref} sx={layerSx} data-sentry-element="Box" data-sentry-component="SectionBox" data-sentry-source-file="index.tsx">
      <Container disableGutters maxWidth="lg" sx={{
      flex: 1,
      px: 2,
      ...sx
    }} {...props} data-sentry-element="Container" data-sentry-source-file="index.tsx">
        {children}
      </Container>
    </Box>;
}
export default forwardRef<HTMLDivElement, SectionBoxProps>(SectionBox);